import { useState, useEffect, useRef } from "react";
import { Link } from "@/components/common/Link";
export default function AboutSection() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return <section style={{
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(26, 26, 26)",
    fontFamily: 'Inter, "Inter Fallback"',
    paddingTop: "56px",
    paddingBottom: "56px",
    animation: "none 0s ease 0s 1 normal none running",
    backgroundColor: "#FFFFFF"
  }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Playfair+Display:wght@700&display=swap');`}</style>
      <div className="page-container">
        <div ref={ref} className={`flex flex-col md:flex-row items-center gap-12 md:gap-20 transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="w-full md:w-1/2 flex justify-center">
            <div className="relative w-full overflow-hidden" style={{
            borderRadius: "12px",
            boxShadow: "rgba(0, 0, 0, 0.1) 0px 8px 24px",
            maxWidth: "568px"
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/image_490be64d2c.jpg" alt="Handwerker bei der Verlegung von Holzboden" className="w-full h-auto block" style={{
              backgroundPosition: "0% 0%",
              backgroundRepeat: "repeat",
              fontFamily: 'Inter, "Inter Fallback"',
              animation: "none 0s ease 0s 1 normal none running",
              maxWidth: "100%",
              objectFit: "cover"
            }} />
            </div>
          </div>

          <div className="w-full md:w-1/2 flex flex-col items-start">
            <div style={{
            width: "32px",
            height: "2px",
            backgroundColor: "#C8A96E",
            marginBottom: "8px"
          }} />

            <p style={{
            color: "rgb(200, 169, 110)",
            fontFamily: 'Inter, "Inter Fallback"',
            fontSize: "14px",
            fontWeight: "500",
            lineHeight: "20px",
            letterSpacing: "1.4px",
            border: "0px solid rgb(200, 169, 110)",
            textTransform: "uppercase",
            animation: "none 0s ease 0s 1 normal none running",
            marginBottom: "12px"
          }}>
              ÜBER RENOVIERUNGEN SCHNEIDER
            </p>

            <h2 style={{
            color: "rgb(26, 26, 26)",
            fontFamily: '"Playfair Display", "Playfair Display Fallback"',
            fontSize: "36px",
            fontWeight: "700",
            lineHeight: "40px",
            border: "0px solid rgb(26, 26, 26)",
            animation: "none 0s ease 0s 1 normal none running",
            marginBottom: "20px"
          }}>
              Qualität und Zuverlässigkeit seit über 15 Jahren
            </h2>

            <p style={{
            color: "lab(35.6337 -1.58697 -10.8425)",
            fontFamily: 'Inter, "Inter Fallback"',
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "26px",
            border: "0px solid lab(35.6337 -1.58697 -10.8425)",
            animation: "none 0s ease 0s 1 normal none running",
            marginBottom: "24px"
          }}>Renovierungen Schneider ist Ihr verlässlicher Partner für alle Renovierungs- und Sanierungsarbeiten im Raum Bielefeld. Das erfahrende Team stehen für individuelle Beratung, handwerkliche Präzision und faire Preise. Ob Altbau-Sanierung oder Neubau-Ausbau – wir finden die beste Lösung für Ihr Projekt.</p>

            <ul className="flex flex-col" style={{
            gap: "12px",
            marginBottom: "32px"
          }}>
              {["Individuelle Beratung & maßgeschneiderte Lösungen", "Renovierung und Entrümpelung aus einer Hand", "Termingerechte, saubere Ausführung"].map((item, i) => <li key={i} className="flex items-center" style={{
              color: "rgb(26, 26, 26)",
              fontFamily: 'Inter, "Inter Fallback"',
              fontSize: "16px",
              fontWeight: "400",
              lineHeight: "24px",
              border: "0px solid rgb(26, 26, 26)",
              textAlign: "left",
              animation: "none 0s ease 0s 1 normal none running",
              gap: "12px"
            }}>
                  <span className="flex-shrink-0" style={{
                color: "#C8A96E",
                width: "20px",
                height: "20px"
              }} dangerouslySetInnerHTML={{
                __html: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21.801 10A10 10 0 1 1 17 3.335"></path><path d="m9 11 3 3L22 4"></path></svg>`
              }} />
                  <span>{item}</span>
                </li>)}
            </ul>

            <Link to="/AboutUsPage" className="cursor-pointer hover:opacity-90 transition-all duration-150" style={{
            color: "rgb(255, 255, 255)",
            fontFamily: 'Inter, "Inter Fallback"',
            fontSize: "14px",
            fontWeight: "600",
            lineHeight: "20px",
            backgroundImage: "linear-gradient(to right in oklab, rgb(200, 169, 110) 0%, rgb(212, 188, 143) 100%)",
            borderRadius: "3.35544e+07px",
            border: "0px solid rgb(255, 255, 255)",
            padding: "10px 32px",
            animation: "none 0s ease 0s 1 normal none running",
            display: "inline-block",
            textDecoration: "none"
          }}>
              Mehr über uns
            </Link>
          </div>
        </div>
      </div>
    </section>;
}